import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/our-services")({
  beforeLoad: () => {
    throw redirect({ to: "/services", statusCode: 301 });
  },
});
